module.exports = __webpack_public_path__ + "img/symbol_12.09e28cce.png";